import {Link} from 'react-router-dom'
import {Form, Input, Submit} from 'components/form'
import {useStore} from 'rest/stores'
import {string, object} from 'yup'
import {useContext, useState} from 'react'
import {AppContext} from 'context/AppContext'
import APP_CONFIG from 'constants/clientConfigs'

export const SignInForm = () => {
  const {textColor, hoverTextColor} =
    APP_CONFIG[process.env.REACT_APP_CLIENT_ID]
  const {setUser} = useContext(AppContext)
  const {AuthStore} = useStore()
  const [error, setError] = useState('')

  const {login} = AuthStore
  const schema = object({
    email: string().required(),
    password: string().required(),
  })
  const onSubmit = async data => {
    setError('')
    try {
      const result = await login(data, setUser)

      if (result?.status === 401) {
        setError('Invalid Email/Password combination')
      }
    } catch (error) {
      setError('Something went wrong')
    }
  }

  return (
    <>
      <div className="flex min-h-full flex-1 md:pb-48">
        <div className="flex flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
          <div className="mx-auto w-full max-w-sm lg:w-96">
            <div>
              <h2 className="mt-8 text-2xl/9 font-bold tracking-tight text-gray-900">
                Sign in to your account
              </h2>
              <p className="mt-2 text-sm/6 text-gray-500">
                Not a member?{' '}
                <Link
                  to="/register"
                  className={`font-semibold ${textColor} ${hoverTextColor}`}>
                  Create a new account
                </Link>
              </p>
            </div>

            <div className="mt-10">
              <div>
                <Form schema={schema} onSubmit={onSubmit} className="space-y-6">
                  <div>
                    <Input
                      name="email"
                      type="email"
                      label="Email address"
                      placeholder="Your email address"
                    />
                  </div>

                  <div>
                    <Input
                      name="password"
                      type="password"
                      label="Password"
                      placeholder="Enter your password"
                    />
                  </div>

                  <div className="flex items-center justify-between">
                    <div className="flex gap-3">
                      <div className="flex h-6 shrink-0 items-center">
                        <div className="group grid size-4 grid-cols-1">
                          <svg
                            fill="none"
                            viewBox="0 0 14 14"
                            className="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-[:disabled]:stroke-gray-950/25">
                            <path
                              d="M3 8L6 11L11 3.5"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="opacity-0 group-has-[:checked]:opacity-100"
                            />
                            <path
                              d="M3 7H11"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="opacity-0 group-has-[:indeterminate]:opacity-100"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>

                    <div className="text-sm/6">
                      <Link
                        to="/auth/password-reminder"
                        className={`font-semibold ${textColor} ${hoverTextColor}`}>
                        Forgot password?
                      </Link>
                    </div>
                  </div>
                  {error && (
                    <div className="bg-red-100 my-2 border border-red-400 text-red-700 px-4 py-3 rounded">
                      <strong className="font-bold">Error: </strong>
                      <span className="block sm:inline">{error}</span>
                    </div>
                  )}
                  <div>
                    <Submit className="primary mt-6 ">SIGN IN</Submit>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
